var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBsw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.2 54.2",
    style: {
      enableBackground: "new 0 0 54.2 54.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.gg0{fill:#FFFFFF;}\n\t.gg1{fill:url(#SVGID_1_BSW);}\n\t.gg2{fill:url(#SVGID_00000176742620248492217850000008941572123143446409_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "gg0",
    d: "M27.1,54.2c15,0,27.1-12.1,27.1-27.1C54.2,12.1,42,0,27.1,0C12.1,0,0,12.1,0,27.1C0,42,12.1,54.2,27.1,54.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_BSW",
    gradientUnits: "userSpaceOnUse",
    x1: 36.7806,
    y1: 39.8012,
    x2: 30.3926,
    y2: 4.6092,
    gradientTransform: "matrix(1 0 0 -1 0 55.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF496A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E42648"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "gg1",
    d: "M48,10.2c-1.9,0.4-3.7,0.9-5.1,1.2c-3.4,0.8-6.5,3.3-7.2,8c-0.6,4.2,0.8,6,0.2,10.9 c-1.1,8.6-9.3,11.5-13.1,13.3c-2.2,1-7.6,3.4-11.7,5.2c4.5,3.3,10,5.3,16.1,5.3c15,0,27.1-12.1,27.1-27.1c0-6.4-2.2-12.2-5.9-16.9 C48.2,10.2,48.1,10.2,48,10.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062914791107164500290000013177463998386082734_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.5519,
    y1: 15.1248,
    x2: 29.6757,
    y2: 55.0107,
    gradientTransform: "matrix(1 0 0 -1 0 55.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00181229,
    style: {
      stopColor: "#1158F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#119BED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062914791107164500290000013177463998386082734_)"
    },
    d: "M24,23.1c2.1-4.5,1.3-4.5,2.9-8.8 c2-5.4,8.2-3.8,9.9-3.6c2.8,0.4,3.6-0.6,9.5-1.6c0.3,0,0.6-0.1,0.9-0.1c-5-5.5-12.2-9-20.2-9C16.3,0,7,6.3,2.6,15.4 C11.6,17.6,21.2,22.4,24,23.1z M18.1,4.7c0.8,0.1,4.6,4.9,5.3,17.1c0,0-4.9-1.2-6-3.7C16.6,16,17.7,13.2,18.1,4.7z M48.2,10.2 C48.2,10.2,48.2,10.2,48.2,10.2c0,0-0.1,0-0.2,0C48.1,10.2,48.2,10.2,48.2,10.2z M0,27.1c0-2.2,0.3-4.3,0.7-6.3c1,0.8,2,1.7,3.1,2.8 c7.1,6.5,18.5,11.7,22.7,6.9c0,0,0,0,0,0c-0.8,1-3.7,4.2-9.2,3.2L8.6,46.8C3.3,41.9,0,34.9,0,27.1z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsw);
export default __webpack_public_path__ + "static/media/bsw.fae056e81384906e9fe2a58f87e9e3c5.svg";
export { ForwardRef as ReactComponent };